/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import NavbarTitleBackAction from '/client/src/components/topNavbar/backAction';
import * as FB from './utils/service';
import { facebookConnect, facebookCurrent } from './utils/merchantService';
import { Embed } from './embed';
import { Order } from './order';

import './styles.scss';

type PropsType = {
  match: {
    params: {
      viewTab?: string
    }
  }
};

const items = [
  {
    link: 'pages',
    label: 'Embed'
  },
  {
    link: 'order',
    label: 'Event order'
  }
];

class IntegrationsFB extends React.Component<PropsType> {
  props: PropsType;

  static contextType = DefaultContainerContext;

  state = {
    FB_user: null,
    loading: true,
    state: FB.states.not_login,
    installed_user: '',
    installed_pages: [],
    pages: []
  }

  componentDidMount(): * {
    this.activate();
  }

  activate = async () => {
    try {
      await FB.init();
      await FB.getLoginStatus();
      await this.loadPages();
    } catch (e) {
      console.error('index.jsx : 53');
      console.log(e);

      this.setState({
        // state: e,
        loading: false
      });
    }

    // FB.init()
    //   .then((): Promise => FB.getLoginStatus())
    //   .then((): Promise => this.loadPages())
    //   .fail((state: string) => {
    //     this.setState({
    //       state,
    //       loading: false
    //     });
    //   });
  }

  loadPages = async () => {
    document.getElementById('fb-root').style.display = 'none';

    this.setState({
      state: FB.states.not_login,
      loading: true
    });

    try {
      await FB.hasPermissions();

      const user = await FB.me();

      this.setState({
        FB_user: user
      });

      const data = {
        'access_token': FB.getAccessToken(),
        'facebook_user_id': user.id,
        'user_name': user.name,
        'email_address': user.email
      };

      await facebookConnect(data);

      const _data =  await facebookCurrent();
      const fb_userid = this.state.FB_user.id;
      const iU = _.first(
        _data,
        (fbUser: { facebook_user_id: string | number }): [] => fbUser.facebook_user_id === fb_userid);

      this.setState({
        installed_user: iU,
        installed_pages: iU.facebook_pages
      });

      const pages = await FB.loadFbPages();

      this.setState({ pages, state: FB.states.success, loading: false });
    } catch (state) {
      this.setState({
        loading: false
      });
      document.getElementById('fb-root').style.display = 'block';
    }
  }

  login = async () => {
    await FB.fbLogin();

    // TODO connect intercom
    // $intercom.trackEvent("FACEBOOK_APP_CONNECTED", { type: "connect" });
    this.loadPages();
  }

  relogin = async () => {
    await FB.logout();

    this.login();
  }

  logout = async () => {
    this.setState({
      loading: true
    });
    await FB.disconnect();

    this.setState({
      state: FB.states.not_login,
      FB_user: {},
      loading: false,
      pages: []
    });
  }

  embed = async (page: {}) => {
    this.setState({
      loading: true
    });
    try {
      await FB.install(this.state.FB_user, page);
      this.setState({ loading: false });
      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'success',
        systemDialogTitle: 'Great!',
        systemDialogContent: 'Successfully embedded'
      });
      this.loadPages();
    } catch (e) {
      this.setState({ loading: false });
      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'OAuthException',
        systemDialogContent: e.message
      });
    }
  }
  uninstall = async (page: {}) => {
    this.setState({ loading: true });
    try {
      await FB.uninstall(this.state.FB_user, page);
      this.setState({ loading: false });
      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'success',
        systemDialogTitle: 'Great!',
        systemDialogContent: 'Successfully removed'
      });
      this.loadPages();
    } catch (e) {
      this.setState({ loading: false });
      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'OAuthException',
        systemDialogContent: e.message
      });
    }
  }

  render(): React.Element<'div'> {
    const { match } = this.props;
    const { params: { viewTab } } = match;
    const _viewTab = viewTab ? viewTab.toLowerCase() : 'pages';
    const menuItems = items.map((i: {}, k: number): React.Element<'li'> => {
      return (
        <li
          key={`IntegrationsItemFB-menuItems-${k}`}
          className={`${(_viewTab) === i.link ? 'active' : ''}`}
        >
          <Link to={`/integrations/facebook-app/${i.link}`}>
            {i.label}
          </Link>
        </li>
      );
    });

    return (
      <div className='IntegrationsFB'>
        <NavbarTitleBackAction />

        <div className="sparxo-router-content">
          <div className="sparxo-page-container">
            <div className="event-list">
              <div className="facebook-page">
                <div className="sparxo-integrations-cards">
                  <div className="sparxo-integrations-list" style={{ marginTop: 0 }}>
                    <div
                      className="sparxo-integrations-item"
                      style={{
                        background: 'none',
                        maxWidth: '360px',
                        margin: '0 auto'
                      }}
                    >
                      <div className="media">
                        <div className="media-left">
                          {/* TODO */}
                          <img
                            src={'https://nest.sparxo.com/public/integrations/facebook.jpg'}
                            alt="facebook"
                            className="media-object"
                          />
                        </div>

                        <div className="media-body">
                          <h4 className="media-heading" style={{ fontWeight: 0 }}>
                            Facebook page tab
                          </h4>

                          <span>Sell tickets directly on your FB page</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <p className="text-center">
                  When you create an event in Sparxo the event automatically shows on Facebook
                </p>
                <div className="text-center fb-limit-hint">
                  Only Pages with 2000 or more likes can create custom Page tabs.
                </div>
                <div className="panel panel-default panel-page">
                  <div className="navbar-page-toolbar customers-navbar facebook-navbar">
                    <div className="container-fluid" style={{ height: '50px' }}>
                      <ul className="nav">
                        {menuItems}
                      </ul>

                      {/* !--ko if:!loading()&&state()==states.success -- */}
                      {
                        !this.state.loading && this.state.state === FB.states.success &&
                        <ul className="nav pull-right">
                          <li>
                            <a
                              href="#"
                              data-bind="click:logout"
                              onClick={(): void => this.logout()}
                              style={{
                                border: '1px solid #fff'
                              }}
                            >
                              disconnect
                            </a>
                          </li>
                        </ul>
                      }
                      {/* !--/ko -- */}
                    </div>
                  </div>

                  <div className="panel-body" style={{ minHeight: '500px' }}>
                    {_viewTab === 'pages' ?
                      <Embed
                        pages={this.state.pages}
                        state={this.state.state}
                        loading={this.state.loading}
                        login={this.login}
                        embed={this.embed}
                        uninstall={this.uninstall}
                      /> :
                      <Order
                        pages={this.state.pages}
                        state={this.state.state}
                        relogin={this.relogin}
                      />
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(IntegrationsFB);
